export default __webpack_public_path__ + "static/media/tip3b.1ff1d643.png";